import { CustomChip } from "../../../components/CustomChip/CustomChip";
import {
  TranslateFn,
  getStatusFromValues,
  translateVehicleStatus,
} from "../../../utils/types";
import { TelematicsBadge } from "../../../components/TelematicsBadge/TelematicsBadge";
import { ButtonsListVehicle } from "./ButtonsListVehicle";

/**
 * Columns of the vehicle list.
 *
 * WHY THIS IS A FUNCTION AND NOT A CONST
 * --------------------------------------
 * It used to be an exported array literal with the headers written inline in
 * French ("Immatriculation", "Marque", "Statut"...). Two separate problems in
 * one line each: the strings were never passed through i18next at all, and a
 * module-level array is evaluated exactly once at import - so even wrapping
 * them in `i18n.t()` would have frozen them in whatever language was active
 * when the bundle loaded, which is the bug the sidebar already hit
 * (see containers/Sidebar/DataSideBar.ts).
 *
 * Taking `t` as an argument and calling this from a useMemo keyed on `t` is
 * what makes the header row follow a language switch.
 */
export const getColumnsListVehicle = (t: TranslateFn) => [
  { header: t("common.id", "ID"), field: "vehicleId" },
  {
    header: t("vehicule.registration", "Registration"),
    field: "immatriculation",
  },
  { header: t("vehicule.vin", "VIN"), field: "vin" },
  { header: t("vehicule.brand", "Brand"), field: "brand" },
  { header: t("vehicule.model", "Model"), field: "brandModel" },
  {
    header: t("collaborator.department", "Department"),
    field: "companyDepartment",
  },
  { header: t("collaborator.name", "Last name"), field: "lastname" },
  { header: t("collaborator.firstName", "First name"), field: "firstname" },
  {
    header: t("vehicule.status", "Status"),
    field: "status",
    render: (rowData: Record<string, any>) => {
      return (
        <CustomChip
          // The chip label is now a translation of the CODE. It used to be
          // the French enum key returned by getKeyLabelByValue(), which is
          // why an English session still rendered "LIBRE" / "AFFECTÉ".
          label={translateVehicleStatus(t, rowData?.fleetVehicleStatut)}
          value={getStatusFromValues(rowData?.fleetVehicleStatut)}
        />
      );
    },
  },
  {
    // Compact density: `plan_excluded` renders nothing here on purpose. It is
    // the same answer on every row of the table, so repeating an upgrade
    // prompt down the whole column is nagging rather than informing. The
    // upsell lives on the vehicle detail page, where it is about one vehicle.
    header: t("vehicule.telematics", "Telematics"),
    field: "telematics",
    render: (rowData: Record<string, any>) => (
      <TelematicsBadge telematics={(rowData as TVehicule).telematics} />
    ),
  },
  {
    header: "",
    field: "",
    render: (rowData: Record<string, any>) => {
      return <ButtonsListVehicle vehicle={rowData as TVehicule} />;
    },
  },
];
